import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message, MessagesService } from '@bitapp-srl/ngb-messages';
import { EnvService } from 'src/app/env.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  errors: any = {};

  returnUrl: string;

  logo: string;
  appVersion: string;

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

  constructor(
    private env: EnvService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private messagesService: MessagesService,
    private authenticationService: AuthenticationService
  ) {
    this.logo = this.env.logoName;
    this.appVersion = this.env.version;

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/app';

    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('sessionExpired') == 'true') {
      // this.messagesService.addMessage(new Message('Sessione scaduta, rifai il login.', 'warning');
      localStorage.removeItem('sessionExpired');
    }
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
      // remember: [true],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/app';

    // eslint-disable-next-line eqeqeq
    if (localStorage.getItem('sessionExpired') == 'true') {
      localStorage.removeItem('sessionExpired');
    }
  }

  login(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(
        this.f.username.value,
        this.f.password.value,
        true // this.f.remember.value
      )
      .subscribe(
        (response) => {
          this.router.navigate([this.returnUrl]);
          this.loading = false;
        },
        (error) => {
          this.loading = false;

          let errorMsg = 'Si è verificato un errore';

          if (error && error.error && error.error.error) {
            switch (error.error.error) {
              case 'invalid_credentials':
                errorMsg = 'Credenziali non valide.';
                break;

              case 'server_error':
                errorMsg = 'Errore del server.';
                break;

              case 'invalid_grant':
                errorMsg = 'Permessi negati.';
                break;

              case 'invalid_client':
                errorMsg = 'Errore di configurazione del client.';
                break;

              case 'invalid_scope':
              case 'invalid_request':
              case 'unsupported_grant_type':
                errorMsg = 'Richiesta non valida.';
                break;

              default:
                break;
            }
          }

          if (error && error.error && error.error.errors) {
            this.errors = error.error.errors;
          }

          this.messagesService.addMessage(new Message(errorMsg, 'danger', 5000));
        }
      );
  }
}
